export const getError = state => state.addInactivity.get('error')
export const getIsSubmitting = state => state.addInactivity.get('isSubmitting')
